import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { StateService } from '../services/state.service';
import { State } from '../types/state';

export function workingStateGuard(workingState: State.SIGNAGE | State.PAIRING): CanMatchFn {
  return () => {
    const stateService = inject(StateService);
    const router = inject(Router);
    if (stateService.state === workingState) {
      return true;
    }
    console.debug(`Can't access URL guarded by state ${workingState}, redirecting`);
    return router.parseUrl(stateService.currentStateDefaultUrl);
  };
}
